import React, { useState, useEffect } from 'react';
import './Login.scss';
import '../../resources/main.scss'
import { Link, useNavigate } from 'react-router-dom'
import { loginService } from '../../services/LoginService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Input, Button } from 'antd';
import axios from 'axios';

const Login = () => {
    const [data, setData] = useState({
        email: '',
        password: ''
    })
    const [showPassword, setShowPassword] = useState(false);
    const [resetModalVisible, setResetModalVisible] = useState(false);
    const [resetEmail, setResetEmail] = useState('');
    const navigate = useNavigate();
    const handleChange = event => {
        const { name, value } = event.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }))
    }
    const handleResetModalOpen = () => {
        setResetModalVisible(true);
    };

    const handleResetModalClose = () => {
        setResetModalVisible(false);
    };

    const handleResetEmailChange = e => {
        setResetEmail(e.target.value);
    };

    const handleResetPassword = () => {
        loginService.forgotPassword(resetEmail).then(response => {
            toast.success('Verifica email');

        })
            .catch((err) => {
                toast.error('Email invalid');
            })
        setResetModalVisible(false);
    };
    const handleSubmit = event => {
        event.preventDefault();

        loginService
            .login(data)
            .then(response => {
                loginService.setToken(response.headers.authorization);
                localStorage.setItem('userProfile', JSON.stringify(response.data));
                toast.success('Login successful!');

                console.log(localStorage.getItem('userProfile'));

                if (response.data.is_admin) {
                  navigate('/products');
                } else {
                  if (response.data.is_supplier) {
                    navigate('/fara-oferte')
                  }
                }

            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.data.error === 'Your account is not activated yet.') {
                        toast.error('Error');
                        return;
                    }
                }
                toast.error('Invalid email or password');
            });

    }
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const responseMessage = (response) => {
        loginService.googleAuthCallback(response.credential)
            .then(response => {
                loginService.setToken(response.headers.authorization);
                localStorage.setItem('userProfile', JSON.stringify(response.data));
                toast.success('Login successful!');

            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.data.error) {
                        toast.error(error.response.data.error);
                        return;
                    }
                }
                toast.error('Invalid email or password');
            });
    };

    useEffect(() => {
        /* global google */
        // if(window.google !== undefined){
        //   console.log(google);
        //   window.google.accounts.id.initialize({
        //     client_id: "217937645884-91odkitsarn1mpuafqqept08un58du2l.apps.googleusercontent.com",
        //     callback: responseMessage,
        //     cancel_on_tap_outside: false,
        //   });
        //
        //   window.google.accounts.id.renderButton(document.getElementById("signInDiv"), {
        //     theme: "outline",
        //     size: "large",
        //   });
        //
        //   window.google.accounts.id.prompt();
        // }
    }, [])

    return (
        <div className='standard login'>
            <div className='login__wrapper'>
                    <img src='/images/logo.png' alt='logo' className='login__logo standard__only-mobile' />

                <div className='login__left-part'>
                    <div className='login__container'>

                        <h3 className='login__title'>Bine ai venit! Conectează-te pentru a accesa contul tău.</h3>
                        <form className='login__form login__form' onSubmit={handleSubmit}>
                            <div className='login__field-box'>
                                <input
                                    className='login__field'
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    onChange={handleChange}
                                    required
                                    value={data.email} />
                            </div>
                            <div className='login__field-box login__password-input'>
                                <input
                                    className='login__field'
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Parola"
                                    onChange={handleChange}
                                    required
                                    value={data.password} />
                                <img src={showPassword ? '/images/eye-closed.png' : '/images/eye.png'} alt='see password' className='login__eye-icon' onClick={togglePasswordVisibility} />
                            </div>

                            <div className='login__account-box'>
                                <button type='submit' className='login__submit-button'><h5 className='login__button-writing'>Intra in cont</h5></button>
                            </div>
                        </form>
                        <h5 className='login__accept-terms'>Intrând în cont, accepți <span> Termenii și Condițiile </span> site-ului nostru.</h5>
                    </div>
                    <img src='/images/login-img.svg' alt='login' className="standard__only-mobile login__icon" />

                </div>

                <div className='login__right-part standard__only-desktop'>
                    <img src='/images/logo.png' alt='logo' className='login__desktop-logo' />
                    <h4 className='login__motto'>Împreună, mai rapizi către viitor.</h4>
                    <img src='/images/login-img.svg' alt='login' className="login__icon" />

                </div>
            </div>
            <div id="signInDiv"></div>

        </div>
    );
};

export default Login;
